"use client";

import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemContent } from "@opensea/next-ui-kit";
import { classNames, Skeleton, SkeletonBlock, SkeletonLine, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { useActivityFeedColumns } from "./hooks";
import { ACTIVITY_TABLE_COLUMN_CLASSNAMES } from "./styles";
export function ActivityFeedTableSkeletonRow(t0) {
  const $ = _c(38);
  const {
    overrides
  } = t0;
  const columns = useActivityFeedColumns();
  const {
    size
  } = useTable();
  let T0;
  let t1;
  let t2;
  if ($[0] !== columns.event || $[1] !== columns.item || $[2] !== overrides?.Skeleton?.className || $[3] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    T0 = TableRow;
    if ($[7] !== columns.event || $[8] !== overrides?.Skeleton?.className) {
      t1 = columns.event ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.event()}><Item variant="unstyled"><ItemAvatar size={24}><SkeletonBlock className={classNames("rounded", overrides?.Skeleton?.className)} /></ItemAvatar><ItemContent><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></ItemContent></Item></TableCell> : null;
      $[7] = columns.event;
      $[8] = overrides?.Skeleton?.className;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    t2 = columns.item ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.item}><Item variant="unstyled"><ItemAvatar className={image()}><SkeletonBlock className={overrides?.Skeleton?.className} /></ItemAvatar><ItemContent><Skeleton className="justify-center"><SkeletonLine className={classNames("h-[15px] w-1/4", overrides?.Skeleton?.className)} /><SkeletonLine className={classNames("h-[15px] w-1/2", overrides?.Skeleton?.className)} /></Skeleton></ItemContent></Item></TableCell> : null;
    $[0] = columns.event;
    $[1] = columns.item;
    $[2] = overrides?.Skeleton?.className;
    $[3] = size;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[10] !== columns.price || $[11] !== overrides?.Skeleton?.className) {
    t3 = columns.price ? <TableCell align="right" className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.price}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell> : null;
    $[10] = columns.price;
    $[11] = overrides?.Skeleton?.className;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== columns.rarity || $[14] !== overrides?.Skeleton?.className) {
    t4 = columns.rarity ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.rarity}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell> : null;
    $[13] = columns.rarity;
    $[14] = overrides?.Skeleton?.className;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== columns.quantity || $[17] !== overrides?.Skeleton?.className) {
    t5 = columns.quantity ? <TableCell align="right" className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.quantity}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell> : null;
    $[16] = columns.quantity;
    $[17] = overrides?.Skeleton?.className;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== columns.from || $[20] !== overrides?.Skeleton?.className) {
    t6 = columns.from ? <TableCell align="right" className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.from}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell> : null;
    $[19] = columns.from;
    $[20] = overrides?.Skeleton?.className;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== columns.to || $[23] !== overrides?.Skeleton?.className) {
    t7 = columns.to ? <TableCell align="right" className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.to}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell> : null;
    $[22] = columns.to;
    $[23] = overrides?.Skeleton?.className;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== columns.time || $[26] !== overrides?.Skeleton?.className) {
    t8 = columns.time ? <TableCell align="right" className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.time()}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell> : null;
    $[25] = columns.time;
    $[26] = overrides?.Skeleton?.className;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== T0 || $[29] !== t1 || $[30] !== t2 || $[31] !== t3 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8) {
    t9 = <T0>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</T0>;
    $[28] = T0;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  return t9;
}